import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges,
	DoCheck,
	OnDestroy
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IForm, FormGroupInterface, FORM_TYPE, INPUT_TYPE } from '../types';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { environment } from 'src/environments/environment';
import { DFormHelpers, IDFormControl } from '../d-form/d-form.helpers';
import { FORM_STYLE_CONFIG } from '../d-form/style.config';
import { Location } from '@angular/common';
import { isNullOrUndefined } from 'util';
import { SharedService } from 'projects/services/src/app/shared/shared.service';
const disallowNameConflict = environment.functionalities &&
	environment.functionalities.form &&
	environment.functionalities.form.disallowNameConflict;
const INPUT_GROUP_NAME = 'test';
declare var toastr: any;
@Component({
	selector: 'app-d-form-group',
	templateUrl: './d-form-group.component.html',
	styleUrls: ['./d-form-group.component.css']
})
export class DFormGroupComponent implements OnInit, OnChanges, DoCheck, OnDestroy {
	formGroup: IForm[] = [];
	@Input() label = ''; // do not use label input it is for beta only
	@Input() formArray: FormGroupInterface = { label: '', forms: [] };
	@Input() defaultValues: any;
	@Input() valid = false;
	@Input() disable: boolean;
	@Input() autoReset = false;
	@Input() submitText: string;
	@Input() cancelText: string;
	@Input() formData: any;
	@Output() formDataChange = new EventEmitter();
	@Output() submit = new EventEmitter();
	@Output() cancel = new EventEmitter();
	@Output() validChange = new EventEmitter();
	@Input() type: any = FORM_TYPE.FORM;
	@Input() mapping: any; // for map output
	@Input() dependentValidities = []; // for dependent validities(if all are true then only this form will be valid)
	@Output() formLoaded = new EventEmitter(); // it will emit when form is loaded completely
	@Input() resetVersion = 0; // whenever it changes we reset the form
	@Input() styleOptions = {
		withElementPadding: false
	};
	@Output() control = new EventEmitter<IDFormControl>();
	@Input() fnBuffer = [];
	@Input() fnc: any;
	formControl: IDFormControl;
	formLoadedCompled = false;
	buffer: any = [];
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	constructor(
		private formBuilder: FormBuilder,
		private location: Location,
		private sharedService: SharedService
	) { }

	static getValue(formRef: FormGroup) {
		const formValue = formRef.value;
		for (const property of Object.keys(formValue)) {
			let formProperty = formValue[property];
			if (formProperty instanceof FormGroup) {
				formProperty = this.getValue(formProperty);
			}
			formValue[property] = (formProperty === '') ? null : formProperty;
		}
		return formValue;
	}
	private _formatView() {
		switch (this.formArray.type) {
			case FORM_TYPE.MODAL: {
				this.formArray.direction = this.formArray.direction || 'anti';
				break;
			}
			default: {
				this.formArray.direction = this.formArray.direction || 'normal';
			}
		}
	}

	goBack() {
		this.location.back();
	}

	private _checkIfDuplicateName(formElement, elementNames) {
		const elementName = formElement.name;
		const alreadyExist = elementNames.indexOf(elementName) > -1;
		if (alreadyExist) {
			console.warn('Name Conflict In Form Group:-', elementName);
			if (disallowNameConflict) {
				throw new Error('Name Conflict In Form Group');
			}
		}
		elementNames.push(elementName);
	}

	private _preProcessForm() {
		const elementNames = [];
		const masterLabelDiv = this.formArray.labelDiv;
		const masterInputDiv = this.formArray.inputDiv;
		const masterRow = this.formArray.row;
		this.formArray.forms = this.formArray.forms.filter(form => !form.hide);
		this.formArray.forms.map(form => {
			form.formElements = form.formElements.filter(formElement => !formElement.remove);
			form.formElements.map(formElement => {
				if (!formElement.forceStyle) {
					formElement.inputDiv = masterInputDiv || formElement.inputDiv;
					formElement.labelDiv = masterLabelDiv || formElement.labelDiv;
				}
				if (form.disabled) {
					formElement.disabled = true;
					formElement.fakeRequired = formElement.required;
					formElement.required = false;
				}
				if (masterRow === false && !formElement.forceStyle) {
					formElement.row = false;
				}
				this._checkIfDuplicateName(formElement, elementNames);
				this._processDisabledSelectElement(formElement);
				this._removeDisabledPlaceholder(formElement);
			});
			// form.formElements = this._orderElements(form.formElements);
		});
		const lastForm = this.formArray.forms[this.formArray.forms.length - 1];
		const lastFormElement = lastForm.formElements[lastForm.formElements.length - 1];
		lastFormElement.lastElement = true;
	}

	ngOnInit() {
		this.label = this.formArray.label || this.label;
		this._formatView();
		this._preProcessForm();
		// this.turnDisabledSelectedToDisabledText();
		// this.removeDisabledPlaceholder();
		this.submitText = this.formArray.submitText;
		this.cancelText = this.formArray.cancelText;
		this.formData = this.defaultValues || this.formData;
		this.formGroup = this.formArray.forms.map((form: any) => {
			form.formRef = this.formBuilder.group({});
			return form;
		});
		this.type = this.formArray.type || this.type;
		// if (this.defaultValues) {
		if (!Helpers.isEmptyObj(this.defaultValues) && this.defaultValues) {
			this.bindValue(this.formArray, this.formData);
		}
		const control = DFormHelpers.forms(this.formArray);
		this.formControl = control;
		this.control.emit(control);
	}
	static get TYPE() {
		return FORM_TYPE;
	}

	get TYPE() {
		return FORM_TYPE;
	}

	private _orderElements(formElements: any[]) {
		formElements = formElements.sort((elem1, elem2) => elem1.order - elem2.order);
		return formElements;
	}

	onFormBuildCompleted() {
		this.formLoadedCompled = true;
		if (this.buffer && this.buffer.length) {
			for (const fn of this.buffer) {
				if (typeof fn === 'function') {
					fn();
				}
			}
		}
		this.formLoaded.emit();
	}

	private _removeDisabledPlaceholder(formElement) {
		if (
			((this.disable || formElement.disabled) && !formElement.metaPlaceholder)
		) {
			formElement.placeholder = '';
		}
		return formElement;
	}

	private _processDisabledSelectElement(formElement) {
		if (
			formElement.type === INPUT_TYPE.SELECT &&
			(this.disable || formElement.disabled)
		) {
			formElement.type = INPUT_TYPE.TEXT;
			if (!formElement.fakeRequired) {
				formElement.fakeRequired = formElement.required;
			}
			formElement.required = false;
			formElement.validationType = null;
			formElement.validationName = null;
		}
		return formElement;
	}

	get isModalForm() {
		return this.type === this.TYPE.MODAL;
	}

	get isWithoutStyle() {
		return this.type === this.TYPE.WITHOUT_STYLE;
	}

	get isNormalForm() {
		return this.type === this.TYPE.FORM;
	}
	ngDoCheck() {
		this.valid = this.isValid;
		this.validChange.emit(this.valid);
		if (this.fnBuffer && this.fnBuffer.length) {
			for (let i = 0; i < this.fnBuffer.length; i++) {
				const fn = this.fnBuffer[i]
				// for (const fn of this.fnBuffer) {
				if (this.formLoadedCompled) {
					try {
						fn();

					} catch (e) {
						console.error(e);
					}

				} else {
					this.buffer.push(fn);
				}
			}
			this.fnBuffer.splice(0, this.fnBuffer.length);
		}
	}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.resetVersion) {
			this.reset();
		}
	}




	private get value() {
		let value = {};
		this.formArray.forms.forEach(form => {
			const formName = form.name;
			if (form.formRef) {
				const formValue = DFormGroupComponent.getValue(form.formRef) || null;
				if(formValue && formValue.trainingCenterType && formValue.trainingCenterType === 'JSS Sub Center'){
					formValue.trainingCenterType = 'Online'
				}
				if (formName) {
					value[formName] = formValue;
				} else {
					Object.assign(value, formValue);
				}
			}
		});
		if (this.mapping) {
			value = Helpers.mapObject(value, this.mapping);
		}
		return value;
	}

	private reset() {
		this.formArray.forms.forEach(form => {
			if (!form.formRef) {
				return;
			}
			form.formRef.reset();
			form.formElements.forEach(element => {
				element.value = '';
			});
			form.formRef.markAsPristine();
			form.formRef.markAsUntouched();
		});
	}

	private bindValue(formGroup, value) {
		formGroup.forms.forEach(form => {
			const formName = form.name;
			const NULL_STRING = '';
			form.formElements.forEach(formElement => {
				const formElementName = formElement.name;
				// if (!formElement.value) {
				if (!formElement.value || isNullOrUndefined(formElement.value)) {
					formElement.value = formName
						? (value[formName] &&
							value[formName][formElementName]) ||
						NULL_STRING
						: value[formElementName];
				}
			});
		});
	}

	get disableSubmit() {
		// return true;
		// STRING.EMPTY : null;
		if (this.formArray.onSubmitClickFormValidity) {
			return false;
		}
		return !this.isValid;

		// if (this.isValid) {
		// 	return true;
		// }
		// this.formControl.makeDirty();

		// }
		// return !this.isValid;
	}

	onSubmit() {
		if (this.isValid) {
			const value = Object.assign({}, this.value);
			if (this.autoReset) {
				this.reset();
			}
			this.submit.emit(value);
		} else {
			toastr.error('Please fill valid data!');
			this.formGroup.filter(res => {
				this.sharedService.markFormGroupTouched(res.formRef);
			});
			this.sharedService.setdynamicErroeEventFired(true);
			this.formControl.makeDirty();
			const invalidIds = this.formControl.getInvalidIds();
			Helpers.focuseOn(invalidIds[0]);
		}
	}

	onCancel() {
		const value = Object.assign({}, this.value);
		if (this.autoReset) {
			this.reset();
		}
		this.cancel.emit(value);
	}

	onChange() {
		this.valid = this.isValid;
		this.validChange.emit(this.valid);
		const value = this.value;
		this.formDataChange.emit(value);
	}

	get formClass() {
		if (this.isModalForm) {
			return FORM_STYLE_CONFIG.formGroup.portlet.body.condition.modalForm;
		}
		if (this.isWithoutStyle) {
			return FORM_STYLE_CONFIG.formGroup.portlet.body.condition.withoutStyle;

		}
		if (this.isNormalForm) {
			return FORM_STYLE_CONFIG.formGroup.portlet.body.condition.normalForm;
		}
	}

	get formGroupClass() {
		return this.isNormalForm ?
			this.FORM_STYLE_CONFIG.formGroup.condition.normalForm :
			this.FORM_STYLE_CONFIG.formGroup.condition.notNormalForm;
	}

	get isValid() {
		let isValid = true;
		this.formGroup.forEach(form => {
			if (!form.formRef.valid) {
				isValid = false;
			}
		});
		let dependentValidities = this.dependentValidities || [];
		if (!(this.dependentValidities instanceof Array)) {
			dependentValidities = [this.dependentValidities];
		}
		const allValid = dependentValidities.reduce((c, p) => c && p, true);
		if (isValid && allValid) {
			return true;
		}
		return false;
	}

	ngOnDestroy() {
		this.sharedService.setdynamicErroeEventFired(false);
	}
}
